var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HomeHionDev"},[_c('PageTitle',{attrs:{"icon":"fas fa-user-lock iconInterativoTitulo","main":"PLATAFORMA TÉCNICA HION","sub":"Dashboard Interativo"}}),_c('hr',{staticClass:"ml-2 mr-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }